import { render, staticRenderFns } from "./AddressEditInputs.vue?vue&type=template&id=53b314da&scoped=true&lang=pug&"
import script from "./AddressEditInputs.vue?vue&type=script&lang=js&"
export * from "./AddressEditInputs.vue?vue&type=script&lang=js&"
import style0 from "./AddressEditInputs.vue?vue&type=style&index=0&id=53b314da&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b314da",
  null
  
)

export default component.exports